.headMain {
	margin: 10px 0 0 0;

	display: flex;
	justify-content: space-evenly;
	padding-left: 20px;
	padding-right: 20px;
	align-items: center;

	@media (max-width: 750px) {
		padding-left: 10px;
		padding-right: 10px;
	}

	.main_title {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.buttonFile {
			font-size: 14px;
			font-weight: 500;
			width: 13em;
			margin-left: 15px;

			background-color: #eff0f2;
			padding: 4px;
			text-align: center;
			border-radius: 5px;
			cursor: pointer;

			background-position: left;
			background-repeat: no-repeat;
			background-size: 55px 20px;

			&.PDF {
				background-image: url("../../assets/images/desktop/pdf.svg");

				&:hover {
					background-color: #81ba43;
					color: white;
					background-image: url("../../assets/images/desktop/pdf_white.svg");
				}
			}

			&.Excel {
				background-image: url("../../assets/images/desktop/excel.svg");

				&:hover {
					background-color: #81ba43;
					color: white;
					background-image: url("../../assets/images/desktop/excel-white.svg");
				}
			}

			&.Download {
				background-image: url("../../assets/images/desktop/descargar1.svg");

				&:hover {
					background-color: #81ba43;
					color: white;
					background-image: url("../../assets/images/desktop/descargarblanco.svg");
				}
			}
		}

		.button {
			display: flex;
			align-items: center;
			font-size: 14px;
			font-weight: 500;
			max-width: 100%;
			margin-left: 15px;
			background-color: #81ba43;
			color: white;
			padding: 0.3rem 0.5rem;
			margin: 0.2rem 1rem;
			border-radius: 5px;
			.icon {
				fill: #424242;
				width: 1rem;
				height: 1rem;
				margin-right: 0.5rem;
			}

			&:hover {
				cursor: pointer;
				background-color: #5f9129;
				color: white;
			}
		}

		@media (max-width: 750px) {
			flex-direction: column;
		}
	}

	.title {
		width: 100%;
		display: flex;
		font-size: 20px;
		font-weight: 700;
		align-items: center;
		flex-wrap: wrap;
	}

	.main_back {
		display: flex;
		align-items: center;

		.iconBack {
			cursor: pointer;
			margin: 0 4px;

			@media (max-width: 750px) {
				display: none;
			}
		}

		.buttonBack {
			cursor: pointer;
			display: inline-block;
			font-size: 18px;
			font-weight: 700;
		}
	}

	.title_link {
		font-size: 14px;
		background-color: #ffffff;
		padding: 7px;
		border-radius: 5px;
		color: #424242;
		margin-right: 3px;
		margin-left: 3px;
		cursor: pointer;

		--tw-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16);
		--tw-shadow-colored: 0px 0px 1px var(--tw-shadow-color), 0px 0.5px 2px var(--tw-shadow-color);
		box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);

		@media (max-width: 750px) {
			min-height: 3em;
			margin-bottom: 5px;
		}

		span {
			margin-left: 27px;

			@media (max-width: 500px) {
				margin-left: 0px;
			}
		}

		&.active {
			color: white;
			background-color: #81ba43;
		}

		&.showGeneric {
			background-image: url("../../assets/images/desktop/generico.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&.active {
				background-image: url("../../assets/images/desktop/generico-white.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showInventory {
			background-image: url("../../assets/images/desktop/inventarionegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&.active {
				background-image: url("../../assets/images/desktop/inventarioblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showEmpty {
			background-image: url("../../assets/images/desktop/vacionegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;

			&.active {
				background-image: url("../../assets/images/desktop/vacioblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showPurchase {
			background-image: url("../../assets/images/desktop/compranegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
			font-size: 12px;

			&.active {
				background-image: url("../../assets/images/desktop/comprablanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showOut {
			background-image: url("../../assets/images/desktop/salidanegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
			font-size: 12px;

			&.active {
				background-image: url("../../assets/images/desktop/salidablanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showUsage {
			background-image: url("../../assets/images/desktop/usonegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
			font-size: 12px;

			&.active {
				background-image: url("../../assets/images/desktop/usoblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.showIn {
			background-image: url("../../assets/images/desktop/historialusonegro.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
			font-size: 12px;

			&.active {
				background-image: url("../../assets/images/desktop/historialusoblanco.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		&.otherMovement {
			background-image: url("../../assets/images/desktop/moveblack.svg");
			background-position: left;
			background-repeat: no-repeat;
			background-size: 40px 20px;
			font-size: 12px;

			&.active {
				background-image: url("../../assets/images/desktop/movewhite.svg");
				color: white;
				background-color: #7fb02f;
			}
		}

		@media (max-width: 500px) {
			background-image: initial !important;
		}
	}

	.iconBack {
		cursor: pointer;
		margin-bottom: 4px;
		margin-right: 6px;

		&.button_filter {
			@media (max-width: 750px) {
				display: none;
			}
		}
	}
}

@media (max-width: 750px) {
	.main_title {
		flex: 0 0 100% !important;
		max-width: 100% !important;
	}

	.head_title {
		justify-content: space-evenly;
	}

	.title_link {
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
	}
}
